import { validateNumeric } from '@/EventLogic/util';

export default function (component, config) {
  if (!component.fieldset || !config.blockFieldsets[component.fieldset]) {
    return {
      fieldset: 'Please select a field.'
    };
  }

  if (!config.blockFieldsets[component.fieldset].numeric) {
    return validateMultipleChoice(component);
  }

  return validateNumeric(component);
}

function validateMultipleChoice(component) {
  if (component.compliantChoices.length < 1) {
    return {
      compliantChoices: "Please select at least one valid choice."
    };
  }

  return {};
}
